import { DeviationData } from "../../Deviation/DeviationData";
import { FirebaseData } from "../../General/FirebaseData";
import { LocalData } from "../../General/LocalData";

export class CollectionItemDeviationData extends FirebaseData {

  deviationID: string = ""
  propertyID: string = ""
  deviation?: DeviationData

  setup(data: any) {
    this.deviationID = typeof data.deviationID === "string" ? data.deviationID : "";
    this.propertyID = typeof data.propertyID === "string" ? data.propertyID : "";

    if (this.deviationID && this.propertyID) {
      this.deviation = LocalData.properties.addData(this.propertyID).deviations.addData(this.deviationID)
    } else {
      this.deviation = undefined
    }

    super.setup(data);
  }
}